<script>
    import {
        i18n,
        def,
        i18nStore,
    } from "svelte-translate";

    import en from '../lang/en.json';
    import fr from '../lang/fr.json';
    import nl from '../lang/nl.json';

    import {reservation, steps} from '../stores/reservation-store';
    import switchLanguage from "../../utils/booking-switch-lang";

    i18nStore.addTranslations("en", en);
    i18nStore.addTranslations("fr", fr);
    i18nStore.addTranslations("nl", nl);
    import Logo from "./kojump-logo.svelte";
    let eventTypeName = '';
    $: eventTypeName = $reservation.readableEventTypeName;
</script>

<header class="header | kj-background-main kj-text-light">

<div class="top-navigation | container">
    {#if $steps.currentStep === 1}
        <span class="logo-wrapper logo-wrapper--booking">
            <a href="/" class="logo" aria-label="Home"><Logo/></a>
        </span>
    {:else}
        <span class="logo-wrapper logo-wrapper--nolink">
            <span class="logo"><Logo/></span>
        </span>
    {/if}

    <div class="navigation-wrapper" id="nav">
        <nav role="navigation" id="navigation" class="navigation navigation--booking" aria-label="Primary navigation">
            <h4 use:i18n={def("headerTitle", {eventTypeName})}>{eventTypeName} reservation</h4>
        </nav>
        <nav class="navigation-secondary" aria-label="Secondary navigation">
        {#if $steps.currentStep === 1}
            <ul class="navigation-secondary-list">
                <li class=""><a href="/" class="navigation-back" use:i18n={"headerBackToSite"}>Back to main site</a></li>
            </ul>
            <ul class="navigation-secondary-list">
                <li>
                    {#if window.languagesActive}
                    <ul class="language-selection">
                        {#each window.languageChoices as newLang}
                        <li><a href="/{newLang}/" class="Navigation-link" on:click|preventDefault="{() => switchLanguage(newLang)}" class:activelang={$i18nStore.language===newLang}>{newLang}</a></li>
                        {/each}
                    </ul>
                    {/if}
                </li>
            </ul>
        {/if}
        </nav>
    </div>
</div>

<div class="container">
    <div class="Form-steps {$steps.currentStep === 1 ? 'Form-steps--initial': ''}">
        <ol class="Form-steps-list">
            <li class:u-step--active="{$steps.currentStep === 1}"></li>
            {#if $reservation.eventType === "KObirthday" || $reservation.eventType === ''}
            <li class:u-step--active="{$steps.currentStep === 2}"></li>
            <li class:u-step--active="{$steps.currentStep === 3}"></li>
            <li class:u-step--active="{$steps.currentStep === 4}"></li>
            <li class:u-step--active="{$steps.currentStep === 5}"></li>
            {:else if $reservation.eventType === "KOparty"}
            <li class:u-step--active="{$steps.currentStep === 2}"></li>
            <li class:u-step--active="{$steps.currentStep === 3}"></li>
            {:else}
            <li class:u-step--active="{$steps.currentStep === 3}"></li>
            <li class:u-step--active="{$steps.currentStep === 4}"></li>
            <li class:u-step--active="{$steps.currentStep === 5}"></li>
            {/if}
        </ol>
    </div>
</div>

</header>